module.exports = __webpack_public_path__ + "img/dsLixeira.bd75e488.svg";